import React, { useEffect } from "react";
import { withRouter } from "../util/withRouter";

const HandleAuth = (props) => {
  const urls = [
    "override",
    "compare",
    "defaultTracks",
    "reasonCodes",
    "gritUser",
    "patternsMaintenance",
    "gritItems",
    "subRecalculate",
    "restriction",
    "request",
    "historyPage",
    "outageList",
    "signout",
    "requestHistoryList",
  ];

  useEffect(() => {
    if (!props.authUser &&
      urls.some((subString) => window.location.pathname.includes(subString))
    ) {
      //Check if the URL matches any none redirects
      sessionStorage.setItem(
        "app:redirect",
        window.location.pathname + window.location.search
      ); //Save the path name we want to redirect to
      window.location.href = "/";
    }
  }, []);

  return <div className="loader" />;
};

export default withRouter(HandleAuth);
